module.exports = __webpack_public_path__ + "static/media/w_rainy.bbf41ce8.svg";